

// Helpers *****************************************************
///////////////////////////////////////////////////////////////////////////////////////
"use strict";(function(){HTMLElement.prototype.matchHeight=function(settings){return new MatchHeight(this,settings)};function MatchHeight(wrapEl,settings){this.wrapEl=wrapEl;let default_settings={elements:null,byRow:true,target:null,attributeName:null,attributeValue:null,property:"height",remove:null,events:true,throttle:80};this.settings=Object.assign(Object.assign({},default_settings),settings);if(!this._validateProperty(this.settings.property)){this.settings.property="height"}if(this.settings.events){var $this=this;this._bind=function(){$this._applyAll($this)};if(document.readyState!=="loading"){this._bind()}else{document.addEventListener("DOMContentLoaded",this._bind,{once:true})}if(this.settings.throttle&&this.settings.throttle>0)this._bind=this._throttle(this._bind,this.settings.throttle);this._init()}}MatchHeight.prototype._init=function(){window.addEventListener("resize",this._bind);window.addEventListener("orientationchange",this._bind)};MatchHeight.prototype._unbind=function(){window.removeEventListener("resize",this._bind);window.removeEventListener("orientationchange",this._bind)};MatchHeight.prototype._merge=function(o1,o2){if(o1!=null){for(var i in o1){o2[i]=o1[i]}}return o2};MatchHeight.prototype._throttle=function(fn,threshold){let last,deferTimer;return function(){const now=Date.now();if(last&&now<last+threshold){clearTimeout(deferTimer);deferTimer=setTimeout(function(){last=now;fn()},threshold)}else{last=now;fn()}}};MatchHeight.prototype._applyAll=function($this){if($this==null){$this=this}$this._apply();if($this.settings.attributeName&&$this._validateProperty($this.settings.attributeName)){$this._applyDataApi($this.settings.attributeName)}$this._applyDataApi("data-match-height");$this._applyDataApi("data-mh")};MatchHeight.prototype._validateProperty=function(value){return String(value).toLowerCase().match(/^([a-z-]{2,})$/)};MatchHeight.prototype._parse=function(value){return parseFloat(value)||0};MatchHeight.prototype._rows=function(elements){var $this=this;var tolerance=1,lastTop=-1,listRows=[],rows=[];elements.forEach($that=>{var top=$that.getBoundingClientRect().top-$this._parse(window.getComputedStyle($that).getPropertyValue("margin-top"));if(lastTop!=-1&&Math.floor(Math.abs(lastTop-top))>=tolerance){listRows.push(rows);rows=[];lastTop=-1}rows.push($that);lastTop=top});listRows.push(rows);return listRows};MatchHeight.prototype._applyDataApi=function(property){var $this=this;var $row=Array.from(this.wrapEl.querySelectorAll("["+property+"]"));$row.forEach($el=>{var groupId=$el.getAttribute(property);$this.settings=$this._merge({attributeName:property,attributeValue:groupId},$this.settings);$this._apply()})};MatchHeight.prototype._remove=function(){var $elements=[];var opts=this.settings;if(opts.elements){$elements=Array.from(this.wrapEl.querySelectorAll(opts.elements))}else{if(opts.attributeName&&opts.attributeValue){$elements=Array.from(this.wrapEl.querySelectorAll("["+opts.attributeName+'="'+opts.attributeValue+'"]'))}}$elements.forEach(item=>{item.style.setProperty(opts.property,"");if(item.getAttribute("style")==="")item.removeAttribute("style")})};MatchHeight.prototype._apply=function(){var $this=this;var opts=$this.settings;var $elements=[];if(opts.elements&&opts.elements.trim()!=""){$elements=Array.from(this.wrapEl.querySelectorAll(opts.elements))}else{if(opts.attributeName&&$this._validateProperty(opts.attributeName)&&opts.attributeValue&&opts.attributeValue.trim()!=""){$elements=Array.from(this.wrapEl.querySelectorAll("["+opts.attributeName+'="'+opts.attributeValue+'"]'))}}var rows=[$elements];if(opts.byRow&&!opts.target){$elements.forEach($that=>{var display=window.getComputedStyle($that).getPropertyValue("display");if(display&&(display!=="inline-block"&&display!=="flex"&&display!=="inline-flex")){display="display: block; "}$that.setAttribute("style-cache",$that.getAttribute("style")||"");$that.setAttribute("style",display+"padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; border-top-width: 0; border-bottom-width: 0; height: 100px; overflow: hidden;")});rows=this._rows($elements);$elements.forEach($that=>{$that.setAttribute("style",$that.getAttribute("style-cache")||"");$that.removeAttribute("style-cache");if($that.getAttribute("style")==="")$that.removeAttribute("style")})}rows.forEach($row=>{var targetHeight=0;if(!opts.target){if(opts.byRow&&$row.length<=1){$row.forEach($that=>{$this._resetStyle($that,opts.property)});return}$row.forEach($that=>{var style=$that.getAttribute("style")||"",display=window.getComputedStyle($that).getPropertyValue("display");if(display&&(display!=="inline-block"&&display!=="flex"&&display!=="inline-flex")){display="block"}$that.setAttribute("style","display: "+display+";");var isTarget=true;if(opts.remove){if(opts.remove instanceof NodeList){opts.remove.forEach($el=>{if($that===$el){isTarget=false}})}else{if($that===opts.remove){isTarget=false}}}if(isTarget){if($that.getBoundingClientRect().height>targetHeight){targetHeight=$that.getBoundingClientRect().height}}if(style){$that.setAttribute("style",style)}else{$that.style.setProperty("display","")}if($that.getAttribute("style")==="")$that.removeAttribute("style")})}else{targetHeight=opts.target.getBoundingClientRect().height}$row.forEach($that=>{var verticalPadding=0;if(opts.target&&$that===opts.target){return}verticalPadding=$this._parse(window.getComputedStyle($that).getPropertyValue("padding-top"))+$this._parse(window.getComputedStyle($that).getPropertyValue("padding-bottom"))+$this._parse(window.getComputedStyle($that).getPropertyValue("border-top-width"))+$this._parse(window.getComputedStyle($that).getPropertyValue("border-bottom-width"));$that.style.setProperty(opts.property,targetHeight-verticalPadding+"px");if($that.getBoundingClientRect().height<targetHeight){$that.style.setProperty(opts.property,targetHeight+"px")}if(opts.remove){if(opts.remove instanceof NodeList){var removedItems=Array.from(opts.remove);removedItems.forEach($el=>{if($that===$el){$this._resetStyle($el,opts.property)}})}else{if($that===opts.remove){$this._resetStyle($that,opts.property)}}}})})};MatchHeight.prototype._resetStyle=function($that,property){if(this._validateProperty(property)){$that.style.setProperty(property,"");if($that.getAttribute("style")==="")$that.removeAttribute("style")}}})();

if (window.matchMedia('(hover: hover)').matches) {
  document.body.classList.add('hover');
}

var getNextSibling = function (elem, selector) {
	// Get the next sibling element
	var sibling = elem.nextElementSibling;
	// If there's no selector, return the first sibling
	if (!selector) return sibling;
	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.nextElementSibling
	}
};

document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');


var getPreviousSibling = function (elem, selector) {

	// Get the next sibling element
	var sibling = elem.previousElementSibling;

	// If there's no selector, return the first sibling
	if (!selector) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.previousElementSibling;
	}

};

var getSiblings = function (elem) {
	// Setup siblings array and get the first sibling
	var siblings = [];
	var sibling = elem.parentNode.firstChild;
	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

/*!
 * Determine if an element is in the viewport
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}    elem The element
 * @return {Boolean}      Returns true if element is in the viewport
 */
var isInViewport = function (elem) {
	var distance = elem.getBoundingClientRect();
	return (
		distance.top >= 0 &&
		distance.left >= 0 &&
		distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		distance.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

// var image = document.querySelector('#scrolly-template--23073850261788__content_sliding_cards_TXkPMV .scroll-5');
// console.log(image);
// window.addEventListener('scroll', function (event) {
//   if (isInViewport(image)) {
//     image.classList.add("inview");
//   } else {
//     image.classList.remove("inview");
//   }
// }, false);


// As above just calculates from the top
var isInViewportTop = function (elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.bottom >= 0 &&
    distance.left >= 0 &&
    distance.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

// when scrolling lets not kill the processor
function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

window.addEventListener("load", function(){
  const containers = document.querySelectorAll(".main-content .manual_collection");
  containers.forEach((container) => {			
      container.matchHeight({elements: '.product_card .description'});
      container.matchHeight({elements: '.product_card h4'});
  });
  
  const sliderContainers = document.querySelectorAll("ul.slider-container");
  sliderContainers.forEach((container) => {     
      container.matchHeight({elements: '.builder_text_parent .product-slide'});    
      container.matchHeight({
          elements: '.quote_card-slider .card-content'
      });
  });
});

// Images *****************************************************
document.querySelectorAll('img[loading="lazy"]').forEach(img => {
  const reveal = () => img.classList.add('loaded');
  if (img.complete) {
    reveal();
  } else {
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
  }
});

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('img[loading="lazy"]').forEach(img => {
    const reveal = () => img.classList.add('loaded');
    if (img.complete) {
      reveal();
    } else {
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
    }
  });
});

// Read more *****************************************************
const readMoreObserver = new ResizeObserver((entries) => {
  entries.forEach(({ target }) => {
    const wrap = target.closest('[data-read-more]');
    if (wrap.classList.contains('open')) return;
    wrap.querySelector('.read-more__toggle').hidden = target.scrollHeight <= target.clientHeight + 1;
  });
});

function initReadMore(root = document) {
  root.querySelectorAll('[data-read-more] .read-more__content').forEach((el) => readMoreObserver.observe(el));
}

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.read-more__toggle');
  if (!toggle) return;
  const wrap = toggle.closest('[data-read-more]');
  const open = wrap.classList.toggle('open');
  toggle.setAttribute('aria-expanded', open);
  toggle.textContent = open ? wrap.dataset.less : wrap.dataset.more;
});

initReadMore();
document.addEventListener('shopify:section:load', (e) => initReadMore(e.target));

// Navigation *****************************************************

function cloneNotices() {
  // Get the elements
  var announcements = document.querySelector('#announcements');
  var mainNav = document.querySelector('#mainMenu');
  var searchResults = document.querySelector('#predictiveSearchResults');
  
  // Guard against missing announcements
  if (!announcements) return;
  
  if (mainNav && !document.querySelector('#navAnnouncements')) {
  // Create a copy of it
      var cloneAnn = announcements.cloneNode(true);
      // Update the ID and add a class
      cloneAnn.id = 'navAnnouncements';
      cloneAnn.ariaLabel = 'Menu announcements';
      cloneAnn.classList.add('nav-banner');
      // Inject it into the DOM
      mainNav.insertAdjacentElement("afterbegin", cloneAnn);
  }
  if (searchResults && !document.querySelector('#searchAnnouncements')) {
      var cloneAnnSearch = announcements.cloneNode(true);
      cloneAnnSearch.id = 'searchAnnouncements';
      searchResults.insertAdjacentElement("afterbegin", cloneAnnSearch);
  }
      if (typeof swiffyslider !== 'undefined') {
        try {
          swiffyslider.init(document.body);
        } catch (e) {
          console.warn('Error initializing swiffyslider:', e);
        }
      }
  }

  window.cloneNotices = cloneNotices;

  document.addEventListener('click', function(e) {
  if (e.target.closest('.togglesearch')) {
      setTimeout(cloneNotices, 10);
  }
});

// Function to figure out if there is enough height in the Viewport for menu content to be fixed to the bottom or whether it needs to sccroll with the content
function howTall() {
  document.querySelectorAll('nav li.has_children').forEach(menu_two => {
   // let height = Array.from(menu_two.querySelectorAll('.menu_2 > li')).map(el => el.clientHeight).reduce((a, b) => a + b, 0);
    let rows = menu_two.querySelectorAll('.menu_2 > li');
      let totalHeight = 0; 
      for(let i = 0; i < rows.length; i++) { 
        totalHeight += rows[i].offsetHeight; 
      }
      console.log(totalHeight); 
  });
}

// Tracks whatever had focus before the hamburger opened the main menu, so
// closing it (via the toggle, bgCloser or Escape) can hand focus back.
let navReturnFocusEl = null;

// function to toggle the main navigation
function toggleNav(targetLi, opener) {
  const mainMenu = document.getElementById('mainMenu');
  const wasOpen = document.body.classList.contains('main_menu_open');
  //console.log(targetLi);
  if (wasOpen) {
    document.body.classList.remove('main_menu_open');
    mainMenu.classList.remove('active');
    document.body.classList.remove('alt_nav_active');
    document.querySelector('.hamburger-menu').classList.remove('animate');
    if (navReturnFocusEl && navReturnFocusEl.isConnected) {
      navReturnFocusEl.focus({ preventScroll: true });
    }
    navReturnFocusEl = null;
  } else {
    const active = document.activeElement;
    navReturnFocusEl = opener || (active && active !== document.body ? active : null);

    document.body.classList.add('main_menu_open');
    mainMenu.classList.add('active');
    document.querySelector('.hamburger-menu').classList.add('animate');

    if(targetLi != null) {
      document.querySelectorAll('nav button[aria-haspopup]').forEach(button => {
        let target = button.dataset.target;
        let navstyle = button.dataset.navstyle;
        //console.log(navstyle);
        if(target == targetLi) {
          button.setAttribute('aria-expanded', true);
          if(navstyle == 'alt_green') {
            document.body.classList.add('alt_nav_active');
          } else {
            document.body.classList.remove('alt_nav_active');
          }
        } else {
          button.setAttribute('aria-expanded', false);
        }
      });
    }

    if (document.body.classList.contains('main_menu_opened')) {
    } else {
      document.body.classList.add('main_menu_opened');
      cloneNotices();
    }

    // Move focus into the panel once the open transition has started, rather
    // than leaving it on the hamburger button.
    setTimeout(function() {
      if (!document.body.classList.contains('main_menu_open')) return;
      mainMenu.focus({ preventScroll: true });
    }, 50);
  }

  document.querySelectorAll('.header_menus .nav_toggle').forEach(function(toggle) {
    toggle.setAttribute('aria-expanded', String(!wasOpen));
  });
}

const navQuery = window.matchMedia('(min-width: 900px)')

function navHeights(button) {
  // Function to compare heights and apply sticky or fixed classes, needts the button prop
  setTimeout(function() {
    let screenHeight = window.innerHeight;
    let heightTarget = button.closest('.has_children');
    let rows = heightTarget.querySelectorAll('.nav_ul > li');
    let totalHeight = 0; 
    for(let i = 0; i < rows.length; i++) { 
      totalHeight += rows[i].offsetHeight; 
    }
    // console.log(screenHeight);
    // console.log(totalHeight);
    if (screenHeight > totalHeight) {
      heightTarget.classList.remove('sticky_bottom');
      heightTarget.classList.add('fixed_bottom');
    }
    if (screenHeight <= totalHeight) {
      heightTarget.classList.add('sticky_bottom');
      heightTarget.classList.remove('fixed_bottom');
    }
  }, 50);
}

// Open and close the nav sub navigation
if (document.getElementById('mainMenu')) {
  // First level main nav menu_1
  document.querySelectorAll('nav > .menu_1 > li > button[aria-haspopup]').forEach(button => {
    button.addEventListener('click', () => {

      if(button.getAttribute('aria-expanded') === 'true') {
        if (!navQuery.matches) {
          button.setAttribute('aria-expanded', false);
        }
      } else {
        if (navQuery.matches) {
          document.querySelectorAll('nav > .menu_1 > li > button[aria-haspopup]').forEach(buttons => {
            //console.log(buttons);
            buttons.setAttribute('aria-expanded', false);
          });
        }
        button.setAttribute('aria-expanded', true);
      }
      navHeights(button);

      let navstyle = button.dataset.navstyle;
      //console.log(navstyle);
      if(navstyle == 'alt_green') {
        document.body.classList.add('alt_nav_active');
      }
      if(navstyle == 'reg') {
        //console.log("this fired"); 
        document.body.classList.remove('alt_nav_active');
      }

    });
  });

  // Second and third level main nav menu_2 and menu_3
  document.querySelectorAll('nav .menu_1 .menu_2 button[aria-haspopup]').forEach(button => {
    button.addEventListener('click', () => {

      if(button.getAttribute('aria-expanded') === 'true') {
        button.setAttribute('aria-expanded', false);
      } else {


        // We need the parent ul to scroll to the top on mobile
        if (navQuery.matches) { } else {
          let parentul2 = button.closest('.menu_2');
          parentul2.scrollTop = 0;
        }
        button.setAttribute('aria-expanded', true);
      }

      // const expanded = button.getAttribute('aria-expanded') === 'true' || false;
      // button.setAttribute('aria-expanded', !expanded);

      // on mobile we need to compare the heights
      navHeights(button);
    });
  });
  
  document.querySelectorAll('.menu_1 li ul li.nav_header > button').forEach(headerButton => {
    headerButton.addEventListener('click', () => {

      let parentContainer = headerButton.closest('.has_children');
      let parentButton = parentContainer.querySelector('button[aria-expanded="true"]');
      let menuUl = headerButton.closest('ul');
      //console.log(menuUl);
      menuUl.classList.add('animate-out');
      setTimeout(function() {
        menuUl.classList.remove('animate-out');
      }, 500);
      // console.log(parentButton);
      document.body.classList.remove('alt_nav_active');
      const parentExpanded = parentButton.getAttribute('aria-expanded') === 'true' || false;
      parentButton.setAttribute('aria-expanded', !parentExpanded);

    });
  });

  document.querySelectorAll('.header_menus .nav_toggle').forEach(navToggle => {
    navToggle.addEventListener('click', () => {
      toggleNav(null, navToggle);
    });
  });

  document.querySelectorAll('.header_menus .nav_toggler').forEach(navToggler => {
    navToggler.addEventListener('click', () => {
      let targetLi = navToggler.dataset.targetnav;
      let navstyle = navToggler.dataset.navstyle;
      
      toggleNav(targetLi);

      if(navstyle == 'alt_green') {
        document.body.classList.add('alt_nav_active');
      }
    });
  });

  let bgCloser = document.querySelector('#bgCloser');
  bgCloser.addEventListener('click', () => {
    toggleNav();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains('main_menu_open')) return;
    toggleNav();
  });

};




// Ingredients slideout *****************************************************
///////////////////////////////////////////////////////////////////////////////////////
// Close inner slides only
function closeInnerSlides() {
  document.querySelectorAll('.slideins .slidein_details').forEach( function(ingre) {
    ingre.classList.remove("activeInner");
    ingre.classList.add("slideOut");
    setTimeout(function() {
      ingre.classList.remove("inpageInner");
      ingre.classList.remove("slideOut");
    }, 300);
  });
}

// Close slider and inner slides
function closeSlider() {
  const slideIns = document.getElementById('slideIns');
  setTimeout(function() {
    slideIns.classList.remove("active");
    document.body.classList.remove("nav_up_hidden");
  }, 350);
  closeInnerSlides();
  setTimeout(function() {
    slideIns.classList.remove("inpage");
  }, 800);
}
// Close slider and inner slides
function closeProdSlider() {
  // The open one first - on a PDP a quote slide-in can be open rather than #prodSlideIns
  const slideIns = document.querySelector('.slideins.active') || document.getElementById('prodSlideIns');
  prodSlideinDialog.close();
  removeInfoActives();
  setTimeout(function() {
    slideIns.classList.remove("active");
    document.body.classList.remove("nav_up_hidden");
  }, 350);
  closeInnerSlides();
  setTimeout(function() {
    slideIns.classList.remove("inpage");
  }, 800);
}

// Open Outer Slider only
function openOuterSlider() {
  const slideIns = document.getElementById('slideIns');
  slideIns.classList.add("inpage");
  setTimeout(function() {
    slideIns.classList.add("active");
    document.body.classList.add("nav_up_hidden");
  }, 30);
}
function openProdOuterSlider(id) {
  const slideIns = document.getElementById(id || 'prodSlideIns');
  slideIns.classList.add("inpage");
  setTimeout(function() {
    slideIns.classList.add("active");
    document.body.classList.add("nav_up_hidden");
  }, 30);
}

// remove active states
function removeActives() {
  document.querySelectorAll('.ingredients .ingredient').forEach( function(ingreds) {
    ingreds.classList.remove("active");
  });
}

function ingredientsSlideouts() {
  if ( document.querySelectorAll('.ingredients .ingredient').length ) {
    // console.log("you exist");
    document.querySelectorAll('.ingredients .ingredient').forEach( function(nutri) {
      nutri.addEventListener('click', function(nutrient) {
        nutrient.preventDefault();
        nutrient.stopPropagation();
        
        // Match up our ids and get target
        let nutriId = nutri.getAttribute("id");
        console.log(nutriId);
        let sliderId = 'deets-' + nutriId;
        console.log(sliderId);
        let targetSlide = document.getElementById(sliderId);
        
        const slideOuter = document.getElementById('slideIns') || document.getElementById(nutriId.replace('quoteSlide', 'quoteSlideIns'));        
        // The clicked ingredient is already active so we close it
        if ( nutri.classList.contains("active") ) {
          //closeInnerSlides();
          closeSlider();
          removeActives();
        } else {
          removeActives();
          // The clicked ingredient is not active so we open it but first close any others
          // Check if the container is open
          if ( slideOuter.classList.contains("active") ) {
             // console.log("already open");
             // the container is open so we need to remove the existing ingredients details and add the current details
             closeInnerSlides();
             // Now add the new ingredients
             setTimeout(function() {
               targetSlide.classList.add("inpageInner");
               targetSlide.classList.add("activeInner");
             }, 400);
             // setTimeout(function() {
             //   
             // }, 300);
          } else {
             // the container is closed so we need to open it first then add the current details
             openOuterSlider();
             setTimeout(function() {
               targetSlide.classList.add("inpageInner");
             }, 700);
             setTimeout(function() {
               targetSlide.classList.add("activeInner");
             }, 730);
           }
           // finally lets give the active class
           nutri.classList.add("active");
        }
      });
    });
  }
}

// products page slideout *****************************************************
///////////////////////////////////////////////////////////////////////////////////////

const prodSlideinTriggers = '.product_details .detail-inner .product_info, .slideins_section .product_info';

// remove active states on buttons
function removeInfoActives() {
  document.querySelectorAll(prodSlideinTriggers).forEach( function(infos) {
    infos.classList.remove("active");
    infos.setAttribute('aria-expanded', 'false');
  });
}

// Product slide-ins (#prodSlideIns, quote slide-ins) behave as a modal dialog:
// named after the open panel's heading, focus moves to the close button, the
// rest of the page is inert, Escape closes it and focus goes back to the opener.
const prodSlideinDialog = (function () {
  let openEl = null;
  let returnFocusEl = null;
  let restoreInert = null;

  // Inert every sibling on the way from the slide-in up to <body>. The page
  // content shares <main> with the slide-in, so inerting <body> children alone
  // (makePageInert) would leave it live. The backdrop stays clickable to close.
  function inertAround(el) {
    const els = [];
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      Array.from(node.parentElement.children).forEach(function (sibling) {
        if (sibling === node || sibling.inert || sibling.tagName === 'SCRIPT' || sibling.classList.contains('slidinsCloser')) return;
        els.push(sibling);
      });
    }
    els.forEach(function (sibling) { sibling.inert = true; });
    return function () {
      els.forEach(function (sibling) { sibling.inert = false; });
    };
  }

  function label(outer, slide, trigger) {
    outer.setAttribute('role', 'dialog');
    outer.setAttribute('aria-modal', 'true');
    outer.setAttribute('tabindex', '-1');
    const heading = slide && slide.querySelector('h1, h2, h3, h4');
    if (heading) {
      if (!heading.id) heading.id = slide.id + 'Title';
      outer.setAttribute('aria-labelledby', heading.id);
      outer.removeAttribute('aria-label');
    } else {
      outer.removeAttribute('aria-labelledby');
      outer.setAttribute('aria-label', (trigger.getAttribute('aria-label') || trigger.textContent).replace(/\s+/g, ' ').trim());
    }
  }

  function open(outer, slide, trigger) {
    label(outer, slide, trigger);
    // Switching panels inside an open slide-in keeps the original opener
    if (openEl === outer) return;
    const active = document.activeElement;
    returnFocusEl = active && active !== document.body ? active : trigger;
    openEl = outer;
    restoreInert = inertAround(outer);
    setTimeout(function () {
      if (openEl !== outer) return;
      const closeBtn = outer.querySelector('.ingredientsClose');
      (closeBtn || outer).focus({ preventScroll: true });
    }, 50);
  }

  function close() {
    if (!openEl) return;
    openEl = null;
    if (restoreInert) restoreInert();
    restoreInert = null;
    if (returnFocusEl && returnFocusEl.isConnected) returnFocusEl.focus({ preventScroll: true });
    returnFocusEl = null;
  }

  const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  document.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') {
      closeProdSlider();
      removeActiveStates();
      removeInfoActives();
      return;
    }
    // Wrap Tab inside the slide-in rather than falling out to the browser chrome
    if (e.key !== 'Tab') return;
    const focusables = Array.from(openEl.querySelectorAll(focusableSelector)).filter(function (el) {
      return !el.disabled && el.getClientRects().length > 0;
    });
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && (active === first || active === openEl)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !openEl.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });

  return { open: open, close: close };
})();

// Enter / Space for the div[role="button"] triggers and close controls
function activateOnKeys(el) {
  el.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    el.click();
  });
}

function productSlideouts() {
  if ( document.querySelectorAll('.section--product_extras, .slideins_section').length ) {

    document.querySelectorAll('.slideins .ingredientsClose[role="button"]').forEach(activateOnKeys);

    document.querySelectorAll(prodSlideinTriggers).forEach( function(nutri) {
      //console.log(nutri);
      nutri.setAttribute('aria-haspopup', 'dialog');
      nutri.setAttribute('aria-expanded', 'false');
      if (!nutri.matches('a[href], button')) {
        if (!nutri.hasAttribute('role')) nutri.setAttribute('role', 'button');
        if (!nutri.hasAttribute('tabindex')) nutri.setAttribute('tabindex', '0');
        activateOnKeys(nutri);
      }
      nutri.addEventListener('click', function(nutrient) {
        nutrient.preventDefault();
        nutrient.stopPropagation();
        
        // Match up our ids and get target
        let nutriId = nutri.getAttribute("id");
        //console.log(nutriId);
        let sliderId = nutriId + 'Slider';
        //console.log(sliderId);
        let targetSlide = document.getElementById(sliderId);
        
        const slideOuter = document.getElementById('prodSlideIns') || document.getElementById(nutriId.replace('quoteSlide', 'quoteSlideIns'));        
        // The clicked ingredient is already active so we close it
        if ( nutri.classList.contains("active") ) {
          // closeInnerSlides();
          closeProdSlider();
          removeInfoActives();
        } else {
          removeInfoActives();
          // The clicked ingredient is not active so we open it but first close any others
          // Check if the container is open
          if ( slideOuter.classList.contains("active") ) {
            //console.log("already open");
            // the container is open so we need to remove the existing ingredients details and add the current details
            closeInnerSlides();
            // Now add the new ingredients
            setTimeout(function() {
              targetSlide.classList.add("inpageInner");
            }, 300);
            setTimeout(function() {
              targetSlide.classList.add("activeInner");
            }, 800);
          } else {
            // the container is closed so we need to open it first then add the current details
            const outerId = slideOuter.getAttribute('id');
  openProdOuterSlider(outerId);;
            setTimeout(function() {
              targetSlide.classList.add("inpageInner");
            }, 300);
            setTimeout(function() {
              targetSlide.classList.add("activeInner");
            }, 800);
          }
          // finally lets give the active class
          nutri.classList.add("active");
          nutri.setAttribute('aria-expanded', 'true');
          prodSlideinDialog.open(slideOuter, targetSlide, nutri);
        }
      });
    });
    //console.log("we have product extras");
    
  }
}



// bundles page slideout *****************************************************
///////////////////////////////////////////////////////////////////////////////////////

// remove active states on buttons
function removeBundlesActives() {
  document.querySelectorAll('.collection .container .slideshow .carousel-cell .product_card .extra_info button').forEach( function(infos) {
    infos.classList.remove("active");
  });
  if (document.querySelector('.custom-1596212245979 .subtext > a')) {
    let bundleextrainfo = document.querySelector('.custom-1596212245979 .subtext > a');
    bundleextrainfo.classList.remove("active");
  }
  if (document.querySelector('.custom-1596234550481 .subtext > a')) {
    let subextrainfo = document.querySelector('.custom-1596234550481 .subtext > a');
    subextrainfo.classList.remove("active");
  }
}



function removeActiveStates() {
  if ( document.querySelectorAll('.ingredients .ingredient').length ) {
    removeActives();
  }
  if ( document.querySelectorAll('.product-helpers .info').length ) {
    removeInfoActives();
  }
  if ( document.querySelectorAll('.section--bundles-info').length ) {
    removeBundlesActives();
  }
  if ( document.querySelectorAll('.method_grid .click').length ) {
    removeMethodActives();
  }
  if ( document.querySelectorAll('#shopify-section-feature-columns-page-wellness .click').length ) {
    removeWellActives();
    document.getElementById('slideIns').classList.remove("green", "yellow", "pink");
  }
}

function closeSlideouts() {
  // Global slide closing
  if(document.getElementById('slidinsCloser')) {
    const slidinsCloser = document.getElementById('slidinsCloser');
    slidinsCloser.addEventListener('click', function() {
      closeSlider();
      removeActiveStates();
    });
  }
  
  if (document.getElementById('ingredientsClose')) {
    const slidesCloseBtn = document.getElementById('ingredientsClose');
    slidesCloseBtn.addEventListener('click', function() {
      closeSlider();
      removeActiveStates();
    });
  }
}

function closeProdSlideouts() {
  // Global slide closing
  if(document.getElementById('slidinsProdCloser')) {
    const slidinsProdCloser = document.getElementById('slidinsProdCloser');
    slidinsProdCloser.addEventListener('click', function() {
      closeProdSlider();
      removeActiveStates();
      removeInfoActives();
    });
  }
  
  if (document.getElementById('xProdClose')) {
    const slidesCloseBtn = document.getElementById('xProdClose');
    slidesCloseBtn.addEventListener('click', function() {
      closeProdSlider();
      removeActiveStates();
    });
  }

  document.querySelectorAll('[id^="xCloseSlide-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeProdSlider();
      removeInfoActives();
    });
  });

  document.querySelectorAll('[id^="slidinsCloser-"]').forEach(function(closer) {
    closer.addEventListener('click', function() {
      closeProdSlider();
      removeInfoActives();
    });
  });
}

function distanceScrolled() {
  if (pageYOffset > 5) {
    document.body.classList.add("hideNav");
  } else {
    document.body.classList.remove("hideNav");
  }
}

function viewport() {
  window.addEventListener("scroll", throttle(distanceScrolled, 10));
}



function accordions() {
  
  if(document.querySelector('.accordion .accordion_inner')) {
    
    var headers = document.querySelectorAll('.accordion .accordion_title');
  
    for(var i = 0; i < headers.length; i++) {
    	headers[i].addEventListener('click', openCurrAccordion);
    }
    
    //Use this as the callback if you would like multiple dropdowns to be open
    function openAccordion(e) {
    	var parent = this.parentElement;
    	var article = this.nextElementSibling;
    	
    	if (!parent.classList.contains('open')) {
    		parent.classList.add('open');
        if (article.classList.contains('max_height')) {
          article.style.maxHeight = '500px';
        } else {
          article.style.maxHeight = article.scrollHeight + 'px';
        }
    	}
    	else {
    		parent.classList.remove('open');
    		article.style.maxHeight = '0px';
    	}
    }
    
    //Use this as the callback if you would like no more than one dropdown to be open
    function openCurrAccordion(e) {
    	for(var i = 0; i < headers.length; i++) {
    		var parent = headers[i].parentElement;
    		var article = headers[i].nextElementSibling;
    
    		if (this === headers[i] && !parent.classList.contains('open')) {
    			parent.classList.add('open');
    			if (article.classList.contains('max_height')) {
            article.style.maxHeight = '500px';
          } else {
            article.style.maxHeight = article.scrollHeight + 'px';
          }
    		}
    		else {
    			parent.classList.remove('open');
    			article.style.maxHeight = '0px';
    		}
    	}
    }
  }
}

function toggleAddress() {
  if(document.querySelector('.address-edit-toggle')) {
    document.querySelectorAll('.address .account_address_outer .address > .address-edit-toggle').forEach( function(toggler) {
      console.log("just click");
      toggler.addEventListener('click', function() {
        let addressBelow = getNextSibling(toggler, '.address_edit');
        let buttonBeside = getNextSibling(toggler, '.address-delete');
        let addressAbove = getPreviousSibling(toggler, '.active_address');
        toggler.classList.toggle("active");
        addressBelow.classList.toggle("hide");
        buttonBeside.classList.toggle("hide");
        addressAbove.classList.toggle("inactive");
        if (toggler.classList.contains("active")) {
          toggler.innerHtml = "Edit";
        } else {
          toggler.innerHtml = "Cancel";
        }
      });
    });
    
  }
}

// account pages stuff
// function accounts() {
//   if(document.getElementById('RecoverPassword')) {
//     let RecoverPassword = document.getElementById('RecoverPassword');
//     let HideRecoverPasswordLink = document.getElementById('HideRecoverPasswordLink');
//     let CustomerLoginForm = document.getElementById('CustomerLoginForm');
//     let RecoverPasswordForm = document.getElementById('RecoverPasswordForm');
//     
//     RecoverPassword.addEventListener('click', function() {
//       console.log("yay clicked");
//       CustomerLoginForm.classList.add('hide');
//       RecoverPasswordForm.classList.remove('hide');
//     });
//     
//     HideRecoverPasswordLink.addEventListener('click', function() {
//       console.log("yay clicked");
//       RecoverPasswordForm.classList.add('hide');
//       CustomerLoginForm.classList.remove('hide');
//     });
//   }
// }

function signups() {

  (function() {
    var REDIRECT_PATH = '/pages/thank-you-for-registering';
    // trying to target recaptcha

    let theForm = document.querySelectorAll('.shopify-challenge__container form')[0];
    
    
    if (theForm) {
      console.log("here to register aye?");
      let redirect = document.createElement('input');
      redirect.setAttribute('name', 'return_to');
      redirect.setAttribute('type', 'hidden');
      redirect.value = REDIRECT_PATH;
      theForm.appendChild(redirect);
    }
  })();

}



// Make everything in <body> except `keepEl`'s top-level ancestor inert, for
// modals. Anything already inert is left alone so restoring doesn't un-inert it.
// Returns a function that undoes it.
function makePageInert(keepEl) {
  const els = Array.from(document.body.children).filter(function (child) {
    return !child.contains(keepEl) && child.tagName !== 'SCRIPT' && !child.inert;
  });
  els.forEach(function (child) { child.inert = true; });
  return function () {
    els.forEach(function (child) { child.inert = false; });
  };
}

// Side cart open/close, shared by the header toggles, add-to-cart and the quiz.
// It behaves as a modal dialog: focus moves into it, the rest of the page is
// made inert, Escape closes it and focus goes back to whatever opened it.
const sidecart = (function () {
  let returnFocusEl = null;
  let restoreInert = null;

  function getEl() {
    return document.getElementById('sidecart');
  }

  function isOpen() {
    const sideCart = getEl();
    return !!sideCart && sideCart.classList.contains('alive');
  }

  function setToggles(active) {
    document.querySelectorAll('#cartToggle, #cartToggleTwo').forEach(function (toggle) {
      toggle.classList.toggle('active', active);
    });
  }

  function open() {
    const sideCart = getEl();
    if (!sideCart || isOpen()) return;

    const active = document.activeElement;
    returnFocusEl = active && active !== document.body ? active : null;

    document.body.classList.add('sidecart-active');
    sideCart.classList.add('alive');
    setToggles(true);
    restoreInert = makePageInert(sideCart);
    setTimeout(function () {
      sideCart.classList.add('active');
      // Focus the close button rather than the drawer itself: VoiceOver would
      // otherwise land on the first item in the cart markup, which Liquid Ajax
      // Cart replaces on every follow-up request (gift sync etc.), bouncing it
      // back to the dialog announcement each time.
      if (!isOpen()) return;
      const closeBtn = document.getElementById('closeCartx');
      (closeBtn || sideCart).focus({ preventScroll: true });
    }, 50);
  }

  function close() {
    const sideCart = getEl();
    if (!sideCart || !isOpen()) return;

    sideCart.classList.remove('active');
    document.body.classList.remove('sidecart-active');
    setToggles(false);
    if (restoreInert) restoreInert();
    restoreInert = null;
    if (returnFocusEl && returnFocusEl.isConnected) {
      returnFocusEl.focus({ preventScroll: true });
    }
    returnFocusEl = null;
    setTimeout(function () {
      if (!sideCart.classList.contains('active')) sideCart.classList.remove('alive');
    }, 500);
  }

  return { open: open, close: close, isOpen: isOpen };
})();

window.openSidecart = sidecart.open;
window.closeSidecart = sidecart.close;

function cartToggle(toggleId) {
  let cartToggle = document.getElementById(toggleId);
  if (!cartToggle || !document.getElementById('sidecart')) return;

  cartToggle.addEventListener('click', function (event) {
    event.preventDefault();
    if (sidecart.isOpen()) {
      sidecart.close();
    } else {
      sidecart.open();
    }
  });
}

function closeCartBind() {
  let closeCartx = document.getElementById('closeCartx');
  let closeCart = document.getElementById('closeCart');
  if (!document.getElementById('sidecart')) return;

  if (closeCartx) closeCartx.addEventListener('click', sidecart.close);
  if (closeCart) closeCart.addEventListener('click', sidecart.close);

  // End-of-drawer shortcuts. The checkout button is inside the re-rendered
  // cart markup, so look it up at click time.
  document.getElementById('sidecart').addEventListener('click', function (e) {
    if (e.target.closest('[data-sidecart-close]')) {
      sidecart.close();
    } else if (e.target.closest('[data-sidecart-to-checkout]')) {
      const checkout = document.querySelector('#sidecart [name="checkout"]');
      if (checkout) checkout.focus();
    }
  });

  const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  document.addEventListener('keydown', function (e) {
    if (!sidecart.isOpen()) return;
    if (e.key === 'Escape') {
      sidecart.close();
      return;
    }
    // Wrap Tab inside the drawer. The rest of the page is inert, so without
    // this Tab falls out to the browser chrome after the last control.
    if (e.key !== 'Tab') return;
    const sideCart = document.getElementById('sidecart');
    const focusables = Array.from(sideCart.querySelectorAll(focusableSelector)).filter(function (el) {
      return !el.disabled && el.getClientRects().length > 0;
    });
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && (active === first || active === sideCart)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !sideCart.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });

  // Liquid Ajax Cart replaces the cart markup after every request, which drops
  // keyboard focus to <body>. Remember which control in which line item had
  // focus and put it back on the matching control once the new markup is in.
  let pendingFocus = null;

  document.addEventListener('liquid-ajax-cart:request-start', function () {
    const sideCart = document.getElementById('sidecart');
    const active = document.activeElement;
    if (!sideCart || !sideCart.contains(active) || active === sideCart) return;

    const item = active.closest('.cart_item[data-item-key]');
    pendingFocus = {
      key: item ? item.dataset.itemKey : null,
      index: item ? Array.from(item.querySelectorAll(focusableSelector)).indexOf(active) : -1,
      el: active
    };
  });

  document.addEventListener('liquid-ajax-cart:request-end', function () {
    if (!pendingFocus) return;
    const focus = pendingFocus;
    pendingFocus = null;

    requestAnimationFrame(function () {
      const sideCart = document.getElementById('sidecart');
      if (!sideCart || !sidecart.isOpen()) return;
      if (focus.el.isConnected) return;

      let target = null;
      if (focus.key) {
        const item = sideCart.querySelector('.cart_item[data-item-key="' + CSS.escape(focus.key) + '"]');
        if (item) target = item.querySelectorAll(focusableSelector)[focus.index] || null;
      }
      (target || sideCart).focus({ preventScroll: true });
    });
  });
}

function referCheck() {
  if(document.getElementById('referTerms')) {
    var checkbox = document.getElementById('referTerms');
    var submit_button = document.getElementById('signup');
    checkbox.addEventListener("change", functionname, false);
  }
  
  function functionname(){
    var isChecked = checkbox.checked;
    if(isChecked){ //checked
      submit_button.classList.add("goodtogo");
    }else{ //unchecked
      submit_button.classList.remove("goodtogo");
    }
  }
  
}

function lazyImages() {
  if ('loading' in HTMLImageElement.prototype) {
    var lazyImages = document.querySelectorAll('img.lazyimage');
      
    for (var img of lazyImages) {
      if (!img.complete) {
        img.classList.add('lazyImageWaiting');
        img.addEventListener('load', lazyImageLoad, false);
        img.addEventListener('error', lazyImageError, false);
      }
    }
    
    function lazyImageLoad(e) {
      e.currentTarget.classList.remove('lazyImageWaiting');
    }
    
    function lazyImageError(e) {
      // var parent = e.currentTarget.parentNode;
      e.classList.remove('lazyImageWaiting');
      e.classList.add('lazyImageError');
      setTimeout(function() {
        e.classList.add('lazyImageErrorShow');
      }, 60);
    }
    
  } // if 'loading' supported
  
}
// Quantity buttons on product pages
if (document.querySelector(".qty-input-box")) {

      function decreaseValue(inputBox) {
        let value = parseInt(inputBox.value);
        value = isNaN(value) ? 1 : Math.max(value - 1, 1);
        inputBox.value = value;
      }
    
      function increaseValue(inputBox) {
        let value = parseInt(inputBox.value);
        value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
        inputBox.value = value;

      }

      const qtys = document.querySelectorAll('main .qty-add .qty');

      for (const clicker of qtys) {
        clicker.addEventListener('click', function(event) {
          let inputBox = clicker.querySelector(".qty-input-box");
          if (event.target.classList.contains("minus")) {
            decreaseValue(inputBox);
          } else if (event.target.classList.contains("plus")) {
            increaseValue(inputBox);
          }
        });
      }
}

if(document.querySelector('.image_slides .productimages-nav button')) {

  const thumbs = document.querySelectorAll('.image_slides .productimages-nav button');
  const thumbOuter = document.getElementById('thumbnails');

  function removeActives() {
    for (const thumb of thumbs) {
      thumb.classList.remove('active');
    }
  }
  
  function updateScroll() {
    thumbOuter.scroll({
      top: 100,
      left: 0,
      behavior: "smooth",
    });
  }

  for (const thumb of thumbs) {
    let slider = document.getElementById('mainslides');
    
    thumb.addEventListener('click', function() {
      removeActives();
      thumb.classList.add('active');
      let topPos = thumb.offsetTop;
      let scrollContainer = thumb.closest('.productimages-nav');
      scrollContainer.scroll({
        top: topPos,
        behavior: "smooth",
      });
      let targetThumb = thumb.dataset.targetthumb;
      swiffyslider.slideTo(slider, targetThumb);
    });
  }

}

// Product Modals
if(document.querySelector('.modal_product_images .thumbs-nav')) {

  const btns = document.querySelectorAll('.modal_product_images .thumbs-nav button');

      for (const btn of btns) {
        let swiffery = btn.closest('.productimages');
        let swiffy = swiffery.querySelector('.swiffy-slider');
        btn.addEventListener('click', function() {
          let target = btn.dataset.targetis;
          swiffyslider.slideTo(swiffy, target);
          let leftPos = btn.offsetLeft;
          let scrollContainer = btn.closest('.thumbs-nav');
          scrollContainer.scroll({
            left: leftPos,
            behavior: "smooth",
          });

        });
      }
}

function subSelectors() {
  if(document.querySelector('.main-content .collection_modal .ab_subscriptions')) {
    document.querySelectorAll('.main-content .collection_modal .ab_subscriptions').forEach( function(subs) {
      subs.classList.add('green');
      let subs_time = subs.querySelector(".subs_time");
      let one_time = subs.querySelector(".one_time");
      let selling_plan_on = subs_time.querySelector(".selling_plan_on");
      let selling_plan_off = one_time.querySelector(".selling_plan_off");
      let selling_plan_onetime = subs.querySelector(".selling_plan_onetime");
      
      selling_plan_on.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          subs_time.classList.add('active');
          one_time.classList.remove('active');
          selling_plan_onetime.checked = false;
        }
      });
      selling_plan_off.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          one_time.classList.add('active');
          subs_time.classList.remove('active');
          selling_plan_onetime.checked = true;
        }
      }); 
    });
    
  }
}

// Binds the subscribe/one-time selling-plan chooser toggle. The markup in
// snippets/add-to-cart-form-collection.liquid ships this same logic as an
// inline <script>, which only runs when the browser parses it as part of the
// initial page HTML. When that snippet's markup is instead injected via
// innerHTML (e.g. the product modal below), inline <script> tags never
// execute, so the modal needs to call this explicitly after injection.
function bindSellingPlanChooser(scopeEl) {
  scopeEl.querySelectorAll('.ab_subscriptions').forEach(function(subs) {
    const formElement = subs.closest('form') || scopeEl;
    const sellingPlanOn = subs.querySelector('.selling_plan_on');
    const sellingPlanOff = subs.querySelector('.selling_plan_off');
    const sellingPlanOnetime = subs.querySelector('.selling_plan_onetime');
    const subsTime = subs.querySelector('#subs_time');
    const oneTime = subs.querySelector('#one_time');

    if (sellingPlanOn) {
      sellingPlanOn.addEventListener('change', function(e) {
        if (e.currentTarget.checked) {
          formElement.classList.add('subs_active');
          document.body.classList.add('addto_ui_subs_active');
          if (subsTime) subsTime.classList.add('active');
          if (oneTime) oneTime.classList.remove('active');
          if (sellingPlanOnetime) sellingPlanOnetime.checked = false;
        }
      });
    }

    if (sellingPlanOff) {
      sellingPlanOff.addEventListener('change', function(e) {
        if (e.currentTarget.checked) {
          formElement.classList.remove('subs_active');
          document.body.classList.remove('addto_ui_subs_active');
          if (oneTime) oneTime.classList.add('active');
          if (subsTime) subsTime.classList.remove('active');
          if (sellingPlanOnetime) sellingPlanOnetime.checked = true;
        }
      });
    }
  });
}

// Generic product modal (dynamic fetch via Section Rendering API) *********
// Single global instance: any element with `.product-modal-trigger` and a
// `data-product-handle` opens the same modal, fetched on demand and cached
// per handle, instead of every product card rendering its own hidden modal.
function productModal() {
  const modalEl = document.getElementById('productModalRoot');
  if (!modalEl) return;

  const modalCache = {};
  let _addFromModal = false;
  let _modalTrigger = null;
  let _restoreInert = null;

  function closeProductModal() {
    if (!modalEl.classList.contains('modal--is-active')) return;
    if (_restoreInert) _restoreInert();
    _restoreInert = null;
    // Hand focus back to the card that opened the modal before its markup is
    // cleared. This runs before the sidecart opens on add-to-cart (theme.js
    // registers its request-end listener first), so the sidecart then returns
    // focus to the card rather than to a button that no longer exists.
    const active = document.activeElement;
    if ((!active || active === document.body || modalEl.contains(active)) && _modalTrigger && _modalTrigger.isConnected) {
      _modalTrigger.focus({ preventScroll: true });
    }
    modalEl.classList.remove('modal--is-active');
    modalEl.classList.add('modal--is-leaving');
    document.body.classList.remove('nav_up_hiding');
    setTimeout(function() { document.body.classList.remove('nav_up_hidden'); }, 50);
    setTimeout(function() {
      modalEl.classList.remove('modal--in-dom');
      modalEl.classList.remove('modal--is-leaving');
      modalEl.innerHTML = '';
    }, 600);
  }

  function openProductModal(handle, variantId) {
    if (!handle) return;
    const cacheKey = handle + (variantId ? ':' + variantId : '');

    const inject = function(html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      modalEl.innerHTML = tmp.firstElementChild ? tmp.firstElementChild.innerHTML : html;

      if (typeof swiffyslider !== 'undefined') {
        try { swiffyslider.init(modalEl); } catch (e) {}
      }

      modalEl.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
        const reveal = function() { img.classList.add('loaded'); };
        if (img.complete) reveal();
        else {
          img.addEventListener('load', reveal, { once: true });
          img.addEventListener('error', reveal, { once: true });
        }
      });

      modalEl.querySelectorAll('.modal_product_images .thumbs-nav button').forEach(function(btn) {
        const swiffy = btn.closest('.productimages') ? btn.closest('.productimages').querySelector('.swiffy-slider') : null;
        if (!swiffy) return;
        btn.addEventListener('click', function() {
          swiffyslider.slideTo(swiffy, btn.dataset.targetis);
          btn.closest('.thumbs-nav').scroll({ left: btn.offsetLeft, behavior: 'smooth' });
        });
      });

      // Accordions scoped to the modal, so they don't double-fire the page-level accordions() handler
      const modalAccHeaders = Array.from(modalEl.querySelectorAll('.accordion .accordion_title'));
      modalAccHeaders.forEach(function(header) {
        header.addEventListener('click', function() {
          modalAccHeaders.forEach(function(h) {
            const parent = h.parentElement;
            const body = h.nextElementSibling;
            if (!body) return;
            if (h === header && !parent.classList.contains('open')) {
              parent.classList.add('open');
              body.style.maxHeight = body.classList.contains('max_height') ? '500px' : body.scrollHeight + 'px';
            } else {
              parent.classList.remove('open');
              body.style.maxHeight = '0px';
            }
          });
        });
      });

      modalEl.querySelectorAll('.closer').forEach(function(c) {
        c.addEventListener('click', closeProductModal);
      });

      bindSellingPlanChooser(modalEl);

      modalEl.addEventListener('submit', function() { _addFromModal = true; }, { capture: true });

      modalEl.classList.add('modal--in-dom');
      if (!_restoreInert) _restoreInert = makePageInert(modalEl);
      modalEl.focus({ preventScroll: true });
      document.body.classList.add('nav_up_hiding');
      setTimeout(function() {
        modalEl.classList.add('modal--is-active');
        document.body.classList.add('nav_up_hidden');
      }, 50);
    };

    if (modalCache[cacheKey]) { inject(modalCache[cacheKey]); return; }

    let url = '/products/' + handle + '?sections=product-modal';
    if (variantId) url += '&variant=' + variantId;

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const html = data['product-modal'];
        if (!html) return;
        modalCache[cacheKey] = html;
        inject(html);
      })
      .catch(function() {});
  }

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.product-modal-trigger');
    if (!trigger) return;
    e.preventDefault();
    _modalTrigger = trigger;
    openProductModal(trigger.dataset.productHandle, trigger.dataset.variantId);
  });

  document.addEventListener('liquid-ajax-cart:request-end', function(e) {
    const requestState = e.detail.requestState;
    if (_addFromModal && requestState.requestType === 'add' && requestState.responseData && requestState.responseData.ok) {
      closeProductModal();
    }
    _addFromModal = false;
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeProductModal();
  });

  // bfcache restore: browser rehydrates the frozen DOM with modal still open
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      modalEl.classList.remove('modal--is-active', 'modal--is-leaving', 'modal--in-dom');
      document.body.classList.remove('nav_up_hiding', 'nav_up_hidden');
      if (_restoreInert) _restoreInert();
      _restoreInert = null;
    }
  });
}

subSelectors();


// Initial functions
function init() {

    cartToggle('cartToggle');
    cartToggle('cartToggleTwo');
    closeCartBind();
    lazyImages();
    if(document.querySelector('.account_area')) {
      //console.log("#### Account Page ###");
      //accounts();
      toggleAddress();
    } else {
      //slideShows();
      accordions();
    }
    productSlideouts();
    closeSlideouts();
    closeProdSlideouts();
    ingredientsSlideouts();
    viewport();
    distanceScrolled();
    signups();
    referCheck();
    productModal();
}


// run once 
init();

// animate the Homepage A+B logo on scroll

const logo = document.querySelector('#logo-footer-svg');

if (logo) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        logo.classList.add('is-expanded');
      } else {
        logo.classList.remove('is-expanded');
      }
    },
    {
      threshold: 0.2
    }
  );

  observer.observe(logo);
}


// Slider
(function () {
    function sliderStep(track) {
        var slides = track.children;
        if (slides.length < 2) return track.clientWidth;
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }
    
    function sliderAtEnd(track) {
        return track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }

    function sliderIndex(track) {
        var last = track.children.length - 1;
        if (sliderAtEnd(track)) return last;
        return Math.min(last, Math.round(track.scrollLeft / sliderStep(track)));
    }

    function sliderTarget(track, dir) {
        var step = sliderStep(track);
        var max = track.scrollWidth - track.clientWidth;
        var pos = track.scrollLeft / step;
        var to = dir === 'prev' ? Math.ceil(pos - 0.05) - 1 : Math.floor(pos + 0.05) + 1;
        return Math.max(0, Math.min(max, to * step));
    }

    function sliderPerView(track) {
        var step = sliderStep(track);
        if (!step) return 1;
        return Math.max(1, Math.round(track.clientWidth / step));
    }

    function sliderScreens(track) {
        var total = track.children.length;
        if (!total) return 1;
        return Math.max(1, Math.ceil(total / sliderPerView(track)));
    }

    function sliderScreen(track) {
        var last = sliderScreens(track) - 1;
        if (sliderAtEnd(track)) return last;
        return Math.min(last, Math.floor(sliderIndex(track) / sliderPerView(track)));
    }

    function sliderMarkActive(track) {
        var bounds = track.getBoundingClientRect();
        var slides = track.children;
        var found = false;

        Array.prototype.forEach.call(slides, function (slide) {
            var rect = slide.getBoundingClientRect();
            var active = rect.left >= bounds.left - 1 && rect.right <= bounds.right + 1;
            if (active) found = true;
            slide.classList.toggle('is-active', active);
        });

        if (!found && slides.length) {
            slides[sliderIndex(track)].classList.add('is-active');
        }
    }

    function sliderSync(track) {
        var slider = track.closest('.content-slider');
        if (!slider) return;

        sliderMarkActive(track);

        var max = track.scrollWidth - track.clientWidth - 1;
        var screens = sliderScreens(track);
        var current = sliderScreen(track);

        slider.querySelectorAll('[data-slider-dir]').forEach(function (button) {
            button.disabled = button.dataset.sliderDir === 'prev'
                ? track.scrollLeft <= 1
                : track.scrollLeft >= max;
        });
        var dots = slider.querySelector('.content-slider__dots');
        if (dots) dots.hidden = screens < 2;

        slider.querySelectorAll('.content-slider__dot').forEach(function (dot, index) {
            dot.hidden = index >= screens;
            dot.classList.toggle('active', index === current);
            dot.setAttribute('aria-current', index === current);
        });
    }

    function sliderSyncAll() {
        document.querySelectorAll('.content-slider__track').forEach(sliderSync);
    }

    document.addEventListener('click', function (event) {
        var control = event.target.closest('.content-slider__nav-btn, .content-slider__dot');
        if (!control) return;

        var slider = control.closest('.content-slider');
        var track = slider && slider.querySelector('.content-slider__track');
        if (!track) return;

        event.preventDefault();
        slider.classList.remove('autoplay');

        if (control.dataset.sliderDir) {
            track.scrollTo({ left: sliderTarget(track, control.dataset.sliderDir) });
        } else {
            var screen = Array.prototype.indexOf.call(control.parentElement.children, control);
            track.scrollTo({ left: screen * sliderPerView(track) * sliderStep(track) });
        }
    });

    // Per-track so one slider's scroll can't swallow another's final sync
    var pending = new WeakSet();
    document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track.classList || !track.classList.contains('content-slider__track') || pending.has(track)) return;
        pending.add(track);
        requestAnimationFrame(function () {
            pending.delete(track);
            sliderSync(track);
        });
    }, true);

    document.addEventListener('animationiteration', function (event) {
        var track = event.animationName === 'slider-autoplay' && event.target.querySelector('.content-slider__track');
        if (track) track.scrollTo({ left: sliderAtEnd(track) ? 0 : sliderTarget(track, 'next') });
    });

    window.addEventListener('resize', sliderSyncAll);
    document.addEventListener('shopify:section:load', sliderSyncAll);
    sliderSyncAll();
})();

document.addEventListener('animationend', function (event) {
    if (event.animationName === 'science-tabs-bar') event.target.control.checked = true;
});
